var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsRead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,14 L18,9 C18,5.68629145 15.3137085,3 12,3 C8.68629154,3 6.00000005,5.68629145 6,9 L6,14 C6,14.7285742 5.80521143,15.4116532 5.46487122,16 L18.5351288,16 C18.1947886,15.4116532 18,14.7285742 18,14 Z M22,18 L2,18 C0.666666667,18 0.666666667,16 2,16 C3.1045695,16 4,15.1045694 4,14 L4,9 C4,4.58172193 7.58172205,1 12,1 C16.418278,1 20,4.58172193 20,9 L20,14 C20,15.1045694 20.8954305,16 22,16 C23.3333333,16 23.3333333,18 22,18 Z M14.595,21.5017718 C14.0583034,22.4269783 13.0696029,22.9964562 12,22.9964562 C10.9303971,22.9964562 9.94169664,22.4269783 9.405,21.5017718 C9.01827917,20.8351072 9.49928951,19.9999999 10.27,19.9999999 L13.73,19.9999999 C14.5007105,19.9999999 14.9817208,20.8351072 14.595,21.5017718 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s-21",
    transform: "translate(-1524.000000, -55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1523.130988, 54.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#000000",
    id: "COLOR/-black"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsRead);
export default __webpack_public_path__ + "static/media/notificationsRead.d089749493ee4a5d45d0ebb9fbf2f79f.svg";
export { ForwardRef as ReactComponent };